<template>
  <div>
    <wx-open-launch-weapp
      id="launch-btn"
      style="width:7.5rem;height:100%;display:flex;justify-content: center;align-items: center;"
      username="gh_b9bba3389b3d"
      path="pages/index/index"
      @error="handleErrorFn"
      @launch="handleLaunchFn"
    >
      <!-- vue中需要使用script标签代替template插槽 html中使用template -->
      <script type="text/wxtag-template">
        <style>.btn { width:200px;height:100px; }</style>
        <button class="btn">打开小程序</button>
        <!-- <img class="btn" src="https://oss-joywork.oss-cn-beijing.aliyuncs.com/qcwy/assets/jumpToMiniProgram.jpeg"> -->
      </script>
    </wx-open-launch-weapp>
    <!-- <img src="https://oss-joywork.oss-cn-beijing.aliyuncs.com/qcwy/assets/jumpToMiniProgram.jpeg" alt=""> -->
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
import jssdkAPI from "../api/JSSDK";
export default {
  name: "jumpToMiniprogram",
  data() {
    return {};
  },
  created() {
    this.wxConfig();
  },
  mounted() {
    
  },
  methods:{
    //微信公众号js配置文件
    wxConfig() {
      this.$axios
        .get(jssdkAPI.jssdk.signature, {
          params: { url: window.location.href.split("#")[0] },
        })
        .then((res) => {
          console.log(res);
          wx.config({
            debug: false,
            appId: "wx6c8bdb72dba32bd2", //后台获取
            timestamp: res.data.timestamp, //后台获取
            nonceStr: res.data.noncestr, //后台获取
            signature: res.data.signature, //后台获取
            jsApiList: [
              // 所有要调用的 API 都要加到这个列表中
              "chooseImage",
              "previewImage"
            ],
            openTagList: [
              "wx-open-launch-weapp",
            ]
          });
          wx.ready(function () {
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            // var btn = document.getElementById("launch-btn");
            // btn.addEventListener("launch", function (e) {
            //    alert("打开成功");
            // });
            this.handleLaunchFn();
            this.handleErrorFn();
          });
        }).catch((res) => {
          console.log(res);
        });
    },
    handleLaunchFn(e) {
      console.log("success", e);
    },
    handleErrorFn(e) {
      console.log("fail", e.detail);
    },
    
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/jumpToMiniprogram.vue